import React from "react";

export default function TemplateHeaderView({ data, isProcessing, onUpdate, onGenerate, onBack }) {
  // Check if all required fields are present to enable the button
  const isFormValid = data.name.trim() !== "" && data.comments.trim() !== "";

  return (
    <div className="card shadow-sm border-0 bg-white animate__animated animate__fadeIn">
      <div className="card-header bg-white py-3 border-bottom">
        <h6 className="mb-0 fw-bold text-primary text-uppercase small">New Template Definition</h6>
      </div>
      <div className="card-body p-4">
        <div className="row g-4">
          
          {/* 1. NAME */}
          <div className="col-md-12">
            <label className="extra-small fw-bold text-muted text-uppercase mb-2">Template Name</label>
            <input 
              type="text" className="form-control shadow-none" 
              placeholder="e.g., Q1_2026_Standard_Disclosure"
              value={data.name} onChange={(e) => onUpdate("name", e.target.value)}
            />
          </div>

          {/* 2. CREATED BY (Session Sync) */}
          <div className="col-md-6">
            <label className="extra-small fw-bold text-muted text-uppercase mb-2">Created By</label>
            <input type="text" className="form-control bg-light" value={data.createdBy} readOnly />
          </div>

          {/* 3. CREATED ON (Timestamp Sync) */}
          <div className="col-md-6">
            <label className="extra-small fw-bold text-muted text-uppercase mb-2">Created On</label>
            <input type="text" className="form-control bg-light" value={data.createdOn} readOnly />
          </div>

          {/* 4. COMMENTS (250 Max) */}
          <div className="col-12">
            <label className="extra-small fw-bold text-muted text-uppercase d-flex justify-content-between mb-2">
              <span>Comments</span>
              <span className={data.comments.length >= 250 ? "text-danger" : ""}>{data.comments.length}/250</span>
            </label>
            <textarea 
              className="form-control shadow-none" rows="3" maxLength="250"
              placeholder="Provide context for this template..."
              value={data.comments} onChange={(e) => onUpdate("comments", e.target.value)}
            />
          </div>

          {/* 5. STATUS & VERSION (Defaults) */}
          <div className="col-md-6">
            <label className="extra-small fw-bold text-muted text-uppercase mb-2">Status</label>
            <span className="form-control bg-light fw-bold text-primary small text-uppercase">{data.status}</span>
          </div>
          <div className="col-md-6">
            <label className="extra-small fw-bold text-muted text-uppercase mb-2">Version</label>
            <span className="form-control bg-light fw-bold small">v{data.version}.0</span>
          </div>

        </div>

        {/* ACTIONS */}
        <div className="mt-5 pt-4 border-top d-flex justify-content-between">
          <button className="btn btn-outline-secondary px-4 fw-bold" onClick={onBack}>BACK</button>
          <button 
            className="btn btn-primary px-5 fw-bold shadow-sm" 
            disabled={!isFormValid || isProcessing}
            onClick={onGenerate}
          >
            {isProcessing ? "PROVISIONING S3 INFRASTRUCTURE..." : "GENERATE HEADER"}
          </button>
        </div>
      </div>
    </div>
  );
}